<div class="w-full py-3 px-2 sm:px-4">
  <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
    <div class="flex items-center justify-start gap-1 lg:gap-2">
      <svg class="size-6 cursor-pointer shrink-0" routerLink="/report/ready-products" viewBox="0 0 24 24" fill="none">
        <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
      </svg>
      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/stock/order.png" />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">Other Product List</span>
    </div>
    <div class="w-full md:w-auto">
      <a routerLink="/add-ready-product/non-jewellery-product"
        class="block w-full md:w-auto text-center px-4 py-2 text-xs sm:text-sm font-semibold text-white bg-c19725 rounded-md hover:shadow-md transition-all">Add
        Product</a>
    </div>
  </div>

  <!-- Summary Cards Section -->
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4 mt-2 max-w-[1050px]">
    <!-- Total Cost Card -->
    <div
      class="bg-gradient-to-br from-[#C19725] to-[#8c6d1a] p-3 rounded-xl shadow-md border border-white/20 transform hover:scale-[1.01] transition-all duration-300">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-white/80 text-[9px] font-bold uppercase tracking-wider mb-0.5">Total Cost Price</p>
          <h3 class="text-white text-lg font-black tracking-tight">
            &#8377;{{ totalCostValue | number:'1.2-2' }}
          </h3>
          <!-- <p class="text-white/60 text-[9px] mt-0.5 font-medium">Cost Per Product &times; Quantity</p> -->
        </div>
        <div class="bg-white/20 p-2 rounded-lg backdrop-blur-md border border-white/30">
          <svg class="size-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
      </div>
      <div class="mt-2 flex items-center gap-2">
        <div class="h-1 flex-grow bg-white/20 rounded-full overflow-hidden">
          <div class="h-full bg-white rounded-full w-full opacity-60"></div>
        </div>
        <span class="text-white text-[8px] font-black uppercase whitespace-nowrap">Stock Value</span>
      </div>
    </div>

    <!-- Total Selling Price Card -->
    <div
      class="bg-white p-3 rounded-xl shadow-md border border-gray-100 transform hover:scale-[1.01] transition-all duration-300">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-gray-400 text-[9px] font-bold uppercase tracking-wider mb-0.5">Total Selling Price</p>
          <h3 class="text-gray-900 text-lg font-black tracking-tight">
            &#8377;{{ totalSellingValue | number:'1.2-2' }}
          </h3>
          <!-- <p class="text-gray-400 text-[9px] mt-0.5 font-medium">Selling Price / MRP &times; Quantity</p> -->
        </div>
        <div class="bg-[#fdf9ec] p-2 rounded-lg border border-[#C19725]/20">
          <svg class="size-4 text-[#C19725]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
      </div>
      <div class="mt-2 flex items-center gap-2">
        <div class="h-1 flex-grow bg-gray-100 rounded-full overflow-hidden">
          <div class="h-full bg-[#C19725] rounded-full w-full opacity-40"></div>
        </div>
        <span class="text-[#C19725] text-[8px] font-black uppercase whitespace-nowrap">MRP Linked</span>
      </div>
    </div>
  </div>

  <!-- Filters & Exports -->
  <div class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6">
    <!-- Input Controls Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 items-end gap-3 w-full lg:w-auto">
      <div class="flex items-center gap-2">
        <label class="text-xs font-medium whitespace-nowrap">Rows:</label>
        <select [(ngModel)]="itemsPerPage" (change)="filterTable()"
          class="w-full border border-dcdcdc rounded p-1.5 text-xs bg-white focus:border-c19725 outline-none">
          <option *ngFor="let c of [5, 10, 20, 50]" [value]="c">{{c}}</option>
        </select>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-[10px] font-bold text-gray-400 uppercase">Search</label>
        <input type="text" [(ngModel)]="globalSearchText" (ngModelChange)="filterTable()" placeholder="Global search..."
          class="border border-dcdcdc rounded px-3 py-1.5 text-xs w-full outline-none focus:border-c19725" />
      </div>

      <!-- ================= FROM DATE ================= -->
      <div class="flex flex-col gap-1">
        <label for="startDate" class="text-[10px] font-bold text-gray-400 uppercase">From :</label>
        <input id="startDate" type="date" [(ngModel)]="startDate" (change)="filterTable()"
          class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs focus:outline-none focus:ring-0 focus:border-c19725" />
      </div>

      <!-- ================= TO DATE ================= -->
      <div class="flex flex-col gap-1">
        <label for="endDate" class="text-[10px] font-bold text-gray-400 uppercase">To :</label>
        <input id="endDate" type="date" [(ngModel)]="endDate" (change)="filterTable()"
          class="w-full border border-dcdcdc rounded-[5px] px-3 py-1 text-xs focus:outline-none focus:ring-0 focus:border-c19725" />
      </div>
    </div>

    <!-- Export Buttons Row -->
    <div class="flex items-center gap-2 flex-wrap justify-center w-full lg:w-auto">
      <button (click)="downloadPDF()"
        class="flex-1 md:flex-none text-[#F20707] border border-[#F20707] bg-[#fff6f3] text-xs px-3 py-2 rounded font-medium hover:bg-[#F20707] hover:text-white transition">PDF</button>
      <button (click)="downloadExcel()"
        class="flex-1 md:flex-none text-[#029921] border border-[#029921] bg-[#e6ffe6] text-xs px-3 py-2 rounded font-medium hover:bg-[#029921] hover:text-white transition">Excel</button>
      <button (click)="downloadJSONAll()"
        class="flex-1 md:flex-none text-[#0720EC] border border-[#0720EC] bg-[#E8E6FF] text-xs px-3 py-2 rounded font-medium hover:bg-[#0720EC] hover:text-white transition">JSON</button>
      <button (click)="downloadCSV()"
        class="flex-1 md:flex-none text-[#00ad94] border border-[#00ad94] bg-[#e5fffb] text-xs px-3 py-2 rounded font-medium hover:bg-[#00ad94] hover:text-white transition">CSV</button>

      <div class="relative flex-1 md:flex-none">
        <button (click)="toggleDropdown()"
          class="w-full text-[#B92185] border border-[#B92185] bg-[#FFE1F5] text-xs px-3 py-2 rounded font-medium hover:bg-[#B92185] hover:text-white transition">Columns</button>
        <div *ngIf="showDropdown"
          class="absolute z-[110] mt-2 p-4 bg-white border rounded shadow-2xl right-0 w-64 max-h-80 overflow-y-auto">
          <label *ngFor="let field of selectedFields" class="flex items-center gap-2 text-sm mb-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="field.selected" (change)="saveSelectedFields(); filterTable()"
              class="rounded" /> {{ field.label }}
          </label>
          <div class="border-t pt-2 mt-2 flex flex-col gap-1">
            <button (click)="selectAllFields()" class="text-xs text-blue-600 hover:underline text-left">Select
              All</button>
            <button (click)="deselectAllFields()" class="text-xs text-red-600 hover:underline text-left">Deselect
              All</button>
            <button (click)="restoreColumnSelection()" class="text-xs text-gray-600 hover:underline text-left">Restore
              Defaults</button>
          </div>
        </div>
      </div>
      <button (click)="printTable()"
        class="flex-1 md:flex-none text-[#5606b6] border border-[#5606b6] bg-[#ecddff] text-xs px-3 py-2 rounded font-medium hover:bg-[#5606b6] hover:text-white transition">Print</button>
    </div>
  </div>

  <!-- Table -->
  <div class="overflow-x-auto border border-gray-200 rounded-lg shadow-sm">
    <table class="w-full border-separate border-spacing-0 bg-white">
      <thead class="bg-[#F2F2F2] text-444 text-xs lg:text-sm">
        <tr>
          <th class="p-3 border-r border-b border-gray-300 text-center w-12">No.</th>
          <th *ngFor="let field of selectedFields" [hidden]="!field.selected"
            class="p-2 border-r border-b border-gray-300 text-left">
            <div class="flex flex-col gap-1 min-w-[140px]">
              <input type="text" [(ngModel)]="searchValues[field.key]" (ngModelChange)="filterTable()"
                [placeholder]="'Filter ' + field.label"
                class="border border-dcdcdc p-1.5 rounded text-[10px] outline-none focus:border-c19725 font-normal" />
              <div (click)="sortBy(field.key)" class="cursor-pointer flex items-center justify-between group">
                <span
                  class="font-bold uppercase tracking-tighter text-[11px] group-hover:text-c19725">{{field.label}}</span>
                <svg *ngIf="sortKey === field.key" class="w-3 h-3 text-c19725" viewBox="0 0 24 24">
                  <path [attr.d]="sortDirection === 'asc' ? 'M12 8l6 6H6z' : 'M12 16l-6-6h12z'" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>
          <th class="p-3 border-b border-gray-300 text-center w-24">Action</th>
        </tr>
      </thead>
      <tbody class="text-xs lg:text-sm">
        <tr *ngFor="let item of paginatedStockList; let i = index" class="hover:bg-gray-50 transition-colors">
          <td class="p-3 border-r border-b border-[#D9D9D9] text-center text-gray-500 font-medium">{{ (currentPage - 1)
            * itemsPerPage + i + 1 }}</td>
          <td *ngFor="let field of selectedFields" [hidden]="!field.selected"
            class="p-3 border-r border-b border-[#D9D9D9] text-gray-700">
            {{ item[field.key] }}
          </td>
          <td class="p-3 border-b border-[#D9D9D9] text-center">
            <div class="flex justify-center items-center gap-2">
              <button [routerLink]="[`/add-ready-product/non-jewellery-product/`+item.reference_id]"
                class="p-1 hover:bg-gray-100 rounded transition" title="Edit">
                <svg viewBox="0 0 24 24" class="size-5" fill="none">
                  <path
                    d="M15.552 4.332L19.5109 8.29075M3.2815 16.452L2.75 21.25L7.54788 20.7185L21.25 7.00912V5.39287L18.6071 2.75H16.9909L3.2815 16.452Z"
                    stroke="#C19725" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <button (click)="deleteProduct(item.st_id)" class="p-1 hover:bg-red-50 rounded transition" title="Delete">
                <svg viewBox="0 0 24 25" class="size-5" fill="none">
                  <path d="M10 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M14 12.5V17.5" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M4 7.5H20" stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="#BB0000" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </button>
              <button *ngIf="item.st_distribution === 'retail'" (click)="openRetailModal(item)"
                class="bg-blue-600 text-white text-[10px] font-bold px-2 py-1 rounded shadow-sm hover:bg-blue-700 transition uppercase">
                Retail
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="paginatedStockList.length === 0">
          <td [attr.colspan]="selectedFields.length + 2" class="p-10 text-center text-gray-400 italic">No products found
            match your search criteria.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="flex flex-col sm:flex-row items-center justify-between mt-6 gap-4 border-t pt-4">
    <span class="text-xs text-gray-500 font-medium">Page {{currentPage}} of {{totalPages}}</span>
    <div class="flex items-center gap-1">
      <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
        class="px-3 py-1.5 border rounded-md text-c19725 border-c19725 disabled:opacity-30 disabled:border-gray-300 font-bold transition hover:bg-gray-50">Prev</button>
      <div class="hidden sm:flex gap-1">
        <button *ngFor="let p of pageNumbers" (click)="goToPage(p)" [class.bg-c19725]="p === currentPage"
          [class.text-white]="p === currentPage"
          class="px-3 py-1.5 border rounded-md text-xs font-bold transition border-gray-200">{{p}}</button>
      </div>
      <span class="sm:hidden text-sm font-bold bg-c19725 text-white px-3 py-1 rounded">{{currentPage}}</span>
      <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
        class="px-3 py-1.5 border rounded-md text-c19725 border-c19725 disabled:opacity-30 disabled:border-gray-300 font-bold transition hover:bg-gray-50">Next</button>
    </div>
  </div>
</div>

<!-- Retail Modal Overlay - UPDATED WIDTH -->
<div *ngIf="isRetailModalOpen" class="fixed inset-0 z-[100] flex items-center justify-center p-2 sm:p-4">
  <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="closeRetailModal()"></div>

  <div class="relative w-full max-w-[95vw] lg:max-w-7xl mx-auto z-[101]">
    <div class="relative flex flex-col w-full bg-white rounded-xl shadow-2xl overflow-hidden max-h-[90vh]">

      <!-- Modal Header -->
      <div class="flex items-center justify-between p-4 border-b bg-gray-50">
        <div class="flex items-center gap-2">
          <span class="size-3 bg-c19725 rounded-full animate-pulse"></span>
          <h3 class="text-base sm:text-xl font-bold text-gray-800">Retail Details for: <span
              class="text-c19725">{{selectedStockItem?.st_item_code}}</span></h3>
        </div>
        <button class="text-gray-400 hover:text-red-500 transition-colors text-3xl font-light leading-none"
          (click)="closeRetailModal()">×</button>
      </div>

      <!-- Modal Body -->
      <div class="relative p-2 sm:p-6 flex-auto overflow-y-auto bg-white">
        <app-retail-stock [itemCode]="selectedStockItem?.st_item_code"></app-retail-stock>
      </div>

      <!-- Modal Footer -->
      <div class="flex items-center justify-end p-4 border-t bg-gray-50">
        <button
          class="w-full sm:w-auto bg-gray-800 text-white font-bold text-sm px-8 py-2.5 rounded-lg hover:bg-black transition shadow-lg"
          (click)="closeRetailModal()">
          Close Window
        </button>
      </div>
    </div>
  </div>
</div>